export const environment = {
  production: true,
  hmr: false,
  strapiBaseUrl: '/strapi',
  djangoBaseUrl: '/django',
  mediaBaseUrl: '',
  strapiMarkdownBaseUrl: '',
  audioServer: 'https://media.naturblick.net/audio'
};
